import {
  setIsDarkTheme,
  useAppDispatch,
  setIsSettingsPanelExpanded,
  setChatModeSidePanel,
  setIsVirtuosoOn,
} from 'src/store';
import { ChatModeSidePanel } from 'src/types';

// TODO(olha): after refactoring we can move updateIsDarkTheme to useColorTheme
export const useThemeActions = () => {
  const dispatch = useAppDispatch();

  /**
   * @deprecated
   */
  const toggleSettingsPanelExpanded = (value?: boolean) => {
    dispatch(setIsSettingsPanelExpanded(value));
  };

  const updateIsDarkTheme = (isDark: boolean) => {
    dispatch(setIsDarkTheme(isDark));
  };

  // TODO(olha): WIP Virtuoso
  const toggleVirtuoso = (isOn?: boolean) => {
    dispatch(setIsVirtuosoOn(isOn));
  };

  /**
   * @deprecated
   */
  const updateChatModeSidePanel = (panel: ChatModeSidePanel) => {
    dispatch(setChatModeSidePanel(panel));
  };

  return {
    setIsDarkTheme: updateIsDarkTheme,
    toggleSettingsPanelExpanded,
    updateChatModeSidePanel,
    toggleVirtuoso,
  };
};
